
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { HeaderData } from "~/types/components";

@Component
export default class TheImage extends Vue {
  @Prop() headerData!: HeaderData;
}
